// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import appConfig from './app/envConfig/config';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // Disable noisy missingKey logs (use devtools/network to verify)
    debug: false,
    // Normalize dialects like en-US -> en
    load: 'languageOnly',
    supportedLngs: ['en', 'fr', 'de', 'ar'],
    nonExplicitSupportedLngs: true,
    lng: 'en',
    fallbackLng: 'en',
    backend: {
      loadPath: appConfig.api_url + '/translations/{{lng}}',
      allowMultiLoading: false,
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage', 'cookie'],
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      bindI18n: 'languageChanged',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
      // Wait for translations before first render to avoid missingKey flicker
      useSuspense: true,
    },
  });

// Keep document direction synced with current language (LTR/RTL)
i18n.on('languageChanged', (lng) => {
  if (typeof document !== 'undefined') {
    document.body.dir = lng && lng.startsWith('ar') ? 'rtl' : 'ltr';
  }
});

export default i18n;
